import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import LoadingScreen from "./Loading";
import {
  getIsAuthAdmin,
  getIsAuthLoading,
  getIsAuthLoggedIn,
} from "../store/selectors";

export const AdminRoute = ({ component: Component, ...rest }) => {
  const isLoading = useSelector(getIsAuthLoading);
  const isLoggedIn = useSelector(getIsAuthLoggedIn);
  const isAdminUser = useSelector(getIsAuthAdmin);
  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route
      {...rest}
      render={(props) =>
        isLoading ? (
          <LoadingScreen />
        ) : isLoggedIn && isAdminUser ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const isLoading = useSelector(getIsAuthLoading);
  const isLoggedIn = useSelector(getIsAuthLoggedIn);
  return (
    //Show the component only when the user is logged in
    //Otherwise, redirect the user to /signin page
    <Route
      {...rest}
      render={(props) =>
        isLoading ? (
          <LoadingScreen />
        ) : isLoggedIn ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  );
};

export const PublicRoute = ({
  component: Component,
  restricted = false,
  ...rest
}) => {
  const isLoading = useSelector(getIsAuthLoading);
  const isLoggedIn = useSelector(getIsAuthLoggedIn);
  return (
    // restricted = false meaning public route
    // restricted = true meaning restricted route
    <Route
      {...rest}
      render={(props) =>
        isLoading ? (
          <LoadingScreen />
        ) : isLoggedIn && restricted ? (
          <Redirect to="/onboarding" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};
